import { money } from "./ambassadorApi";

const STATUS = {
  pending: ["Pending · ships soon", "bg-[#f3f2ec] text-[#5f5e5a]"],
  approved: ["Ready to pay", "bg-[#007a3d]/10 text-[#007a3d]"],
  paid: ["Paid", "bg-[#0a0a0b] text-white"],
  void: ["Refunded", "bg-[#ff2a85]/10 text-[#ff2a85]"],
};
const fmt = (iso) => new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });

export const Pill = ({ status }) => {
  const [label, cls] = STATUS[status] || [status, "bg-[#f3f2ec]"];
  return <span className={`inline-flex rounded-full px-2.5 py-1 font-mono-d text-[9px] uppercase tracking-[0.15em] ${cls}`}>{label}</span>;
};

/** Ambassador-facing sales list — commission only, never cost or margin. */
export const SalesTable = ({ sales }) => {
  if (!sales.length) {
    return <p data-testid="amb-sales-empty" className="rounded-2xl border border-dashed border-[#e3e2dc] p-8 text-center text-sm text-[#5f5e5a]">No sales yet. Share your link — your first pre-order will show up here within seconds of payment.</p>;
  }
  return (
    <div data-testid="amb-sales-table" className="border border-[#e3e2dc] rounded-3xl overflow-x-auto bg-[#faf9f6]">
      <table className="w-full text-left min-w-[640px]">
        <thead>
          <tr className="font-mono-d text-[9px] uppercase tracking-[0.2em] text-[#5f5e5a] border-b border-[#e3e2dc]">
            <th className="px-5 py-3">Date</th><th className="px-5 py-3">Order</th><th className="px-5 py-3">Pieces</th><th className="px-5 py-3">Rate</th><th className="px-5 py-3">Status</th><th className="px-5 py-3 text-right">Your commission</th>
          </tr>
        </thead>
        <tbody>
          {sales.map((s) => (
            <tr key={s.id} data-testid={`amb-sale-${s.order_ref}`} className="border-b border-[#e3e2dc] last:border-0 align-top">
              <td className="px-5 py-4 font-mono-d text-xs whitespace-nowrap">{fmt(s.date)}</td>
              <td className="px-5 py-4 font-mono-d text-xs">#{s.order_ref}</td>
              <td className="px-5 py-4 text-xs">
                {s.items.map((i, idx) => <span key={idx} className="block">{i.quantity > 1 ? `${i.quantity}× ` : ""}{i.product_name}{i.size && i.size !== "ONE SIZE" ? ` · ${i.size}` : ""}</span>)}
              </td>
              <td className="px-5 py-4 font-mono-d text-xs">{s.pct}%</td>
              <td className="px-5 py-4"><Pill status={s.status} /></td>
              <td className={`px-5 py-4 font-mono-d text-sm text-right tabular-nums ${s.status === "void" ? "line-through text-[#5f5e5a]" : ""}`}>{money(s.commission_cents)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const PayoutsList = ({ payouts }) => {
  if (!payouts.length) return null;
  return (
    <div data-testid="amb-payouts" className="rounded-3xl border border-[#e3e2dc] bg-[#faf9f6] divide-y divide-[#e3e2dc]">
      {payouts.map((p) => (
        <div key={p.id} className="flex items-center justify-between gap-4 px-5 py-4">
          <div><p className="font-mono-d text-xs">{fmt(p.created_at)}</p><p className="text-[11px] text-[#5f5e5a]">PayPal · {p.status === "success" ? "delivered" : p.status}{p.note ? ` · ${p.note}` : ""}</p></div>
          <p className="font-mono-d text-sm tabular-nums">{money(p.amount_cents)}</p>
        </div>
      ))}
    </div>
  );
};
